/**
 * Org feature flag + per-user permission for operational commitments (not settings).
 */
export function canAccessCommitmentsModule(account, organization) {
  return !!organization?.hasCommitments && !!account?.isCommitmentsUser;
}
